import { hbs } from 'ember-cli-htmlbars';
export default hbs("<BvChart\n  @option={{this.chartOptions}}\n  @loading={{@loading}}\n  style={{html-safe \"height: 240px;\"}}\n  ...attributes\n/>")